//#region IMPORT
import React from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessGridGridCommon } from '../../../../Components/BusinessGridGridCommon';
import { getColumnDefs1, getColumnDefs2 } from './MEN_BASIC_ColumnDefs';
//#endregion

function MEN_BASIC(props) {
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = getColumnDefs2(props);

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Menu"
          printYn="N"
          saveClick={() => props.SaveLogic1?.()}
          searchClick={(e) => {
            props.gridRef1?.current?.api?.setQuickFilter(e);
          }}
          grids={
            <BusinessGridGridCommon
              getRowId1={(params) => params.data.no}
              getRowId2={(params) => params.data.no}
              gridRef1={props.gridRef1}
              gridRef2={props.gridRef2}
              columnDefs1={columnDefs1}
              columnDefs2={columnDefs2}
              rowData1={props.rowData1}
              rowData2={props.rowData2}
              setSelectedRowData1={props.setSelectedRowData1}
              setSelectedRowData2={props.setSelectedRowData2}
              setChangedRowData1={props.setChangedRowData1}
              setChangedRowData2={props.setChangedRowData2}
              title1="메뉴정보"
              title2="프로그램정보"
              addClick1={() => {
                props.AddClick1?.();
              }}
              addClick2={() => {
                props.AddClick2?.();
              }}
              refreshClick1={() => {
                props.SearchLogic1?.();
              }}
              deleteClick1={() => {
                props.DeleteClick1?.();
              }}
              deleteClick2={() => {
                props.DeleteClick2?.();
              }}
              onCellClicked1={(e) => {
                props.OnCellClicked1?.(e);
              }}
              onSelectionChanged1={() => {
                props.OnSelectionChanged1?.();
              }}
              onSelectionChanged2={() => {
                props.OnSelectionChanged2?.();
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default MEN_BASIC;
